module.exports = __webpack_public_path__ + "img/assembling.2cf8e974.svg";